var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M36.364,423.7h134.302V88.303H38.345C17.167,88.303,0,105.47,0,126.648v258.759 C0,405.919,16.108,422.67,36.364,423.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 88.3,
    style: {
      fill: "#FFE15A"
    },
    width: 170.67,
    height: 335.39
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M475.636,423.7C495.892,422.67,512,405.919,512,385.406V126.648 c0-21.177-17.167-38.345-38.345-38.345H341.334V423.7H475.636L475.636,423.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCBE82"
    },
    d: "M316.023,284.667c0-2.562-2.077-4.64-4.64-4.64c-0.556,0-1.082,0.114-1.577,0.294 c-2.296-2.042-6.457-7.11-2.282-14.264c0.564,0.439,1.265,0.711,2.035,0.711c1.841,0,3.332-1.492,3.332-3.332 c0-1.454-0.937-2.678-2.236-3.133c3.431-1.75,8.324-5.465,8.072-12.412c-0.359-9.852-8.429-15.29-13.38-13.116 c0.018-0.138,0.042-0.274,0.042-0.416c0-1.815-1.471-3.286-3.286-3.286c-1.116,0-2.098,0.559-2.691,1.409 c-0.202-0.985-0.178-2.814,2.112-4.791c4.253-3.673,9.086-12.469,0.29-18.655c-4.871-3.425-14.182-5.066-17.301-0.386 c-1.353,2.029-0.268,4.945,1.277,5.6c-2.489,1.388-7.211,3.471-10.942,1.843c-5.316-2.319-2.246-6.926-1.063-8.989 c2.078-3.625,0.774-9.569-6.186-9.569c-4.64,0-6.959,4.64-11.598,4.64c-4.639,0-6.959-4.64-11.598-4.64 c-6.959,0-8.264,5.944-6.186,9.569c1.183,2.062,4.253,6.669-1.063,8.989c-3.731,1.629-8.452-0.455-10.942-1.843 c1.544-0.654,2.63-3.57,1.277-5.6c-3.119-4.679-12.43-3.039-17.301,0.386c-8.796,6.186-3.962,14.982,0.29,18.655 c2.29,1.977,2.314,3.807,2.112,4.791c-0.594-0.85-1.576-1.409-2.691-1.409c-1.815,0-3.286,1.471-3.286,3.286 c0,0.142,0.024,0.279,0.042,0.416c-4.951-2.175-13.022,3.264-13.38,13.116c-0.253,6.946,4.641,10.662,8.072,12.412 c-1.299,0.456-2.236,1.679-2.236,3.133c0,1.841,1.492,3.332,3.332,3.332c0.77,0,1.47-0.271,2.035-0.711 c4.175,7.155,0.015,12.222-2.282,14.264c-0.494-0.18-1.021-0.294-1.577-0.294c-2.562,0-4.64,2.077-4.64,4.64 c0,2.406,1.837,4.361,4.182,4.594c-3.198,3.285-6.067,10.525,0.168,18.749c6.814,8.989,23.052,8.264,30.881,8.554 c4.964,0.184,8.698,2.754,10.771,4.614c-1.325,0.817-2.217,2.269-2.217,3.94c0,2.343,1.743,4.26,4,4.575 c0.82,1.312,2.265,2.191,3.926,2.191c1.856,0,3.445-1.097,4.188-2.673c2.45,2.019,4.125,2.866,4.125,2.866s1.675-0.846,4.125-2.866 c0.742,1.575,2.332,2.673,4.188,2.673c1.661,0,3.106-0.879,3.926-2.191c2.257-0.314,4-2.232,4-4.575c0-1.672-0.892-3.124-2.217-3.94 c2.072-1.859,5.806-4.43,10.771-4.614c7.829-0.29,24.067,0.435,30.881-8.554c6.234-8.224,3.366-15.465,0.168-18.749 C314.186,289.027,316.023,287.073,316.023,284.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2AA73"
    },
    d: "M214.246,225.079v67.273c0,7.687,6.231,13.919,13.919,13.919h18.558c6.959,0,9.279,4.64,9.279,4.64 s2.319-4.64,9.279-4.64h18.558c7.687,0,13.919-6.231,13.919-13.919v-67.273c0-1.281-1.038-2.319-2.319-2.319h-78.871 C215.284,222.758,214.246,223.798,214.246,225.079z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 218.88,
    y: 227.4,
    style: {
      fill: "#FF4B55"
    },
    width: 34.796,
    height: 34.796
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M253.681,301.629L253.681,301.629c-19.218,0-34.796-15.578-34.796-34.796l0,0h34.796V301.629z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M258.321,301.629L258.321,301.629v-34.796h34.796l0,0 C293.116,286.051,277.537,301.629,258.321,301.629z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.32,
    y: 227.4,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  })), /*#__PURE__*/React.createElement("rect", {
    x: 263.29,
    y: 227.4,
    style: {
      fill: "#FF4B55"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.26,
    y: 227.4,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.24,
    y: 227.4,
    style: {
      fill: "#FF4B55"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 278.2,
    y: 227.4,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.14,
    y: 227.4,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.18,
    y: 227.4,
    style: {
      fill: "#FF4B55"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.48,
    y: 266.84,
    style: {
      fill: "#FF4B55"
    },
    width: 3.866,
    height: 34.796
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.35,
    y: 266.84,
    style: {
      fill: "#FFE15A"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.09,
    y: 266.84,
    style: {
      fill: "#FFE15A"
    },
    width: 3.866,
    height: 34.796
  })), /*#__PURE__*/React.createElement("rect", {
    x: 238.21,
    y: 266.84,
    style: {
      fill: "#FF4B55"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.81,
    y: 266.84,
    style: {
      fill: "#FFE15A"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.95,
    y: 266.84,
    style: {
      fill: "#FF4B55"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M222.751,299.859v-33.026h-3.866v25.517C218.884,295.449,220.417,298.174,222.751,299.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M226.617,301.474v-34.641h-3.866v33.026C223.878,300.674,225.188,301.233,226.617,301.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M226.617,266.833v34.641c0.505,0.085,1.016,0.156,1.547,0.156h2.319v-34.796L226.617,266.833 L226.617,266.833z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M224.071,260.218c-0.173,0-0.348-0.049-0.503-0.151c-2.281-1.509-2.414-3.082-2.29-3.884 c0.167-1.084,0.973-1.983,2.053-2.292c1.028-0.289,2.054,0.014,2.746,0.819c1.44,1.674,2.927,2.333,4.179,1.87 c0.991-0.367,1.582-1.344,1.582-2.074c0-0.505,0.408-0.914,0.914-0.914s0.914,0.408,0.914,0.914c0,1.598-1.166,3.191-2.774,3.787 c-1.175,0.434-3.538,0.702-6.2-2.391c-0.286-0.33-0.622-0.32-0.86-0.254c-0.324,0.093-0.683,0.381-0.749,0.812 c-0.097,0.63,0.447,1.388,1.492,2.081c0.422,0.278,0.536,0.846,0.258,1.267C224.658,260.073,224.367,260.218,224.071,260.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M248.604,260.218c-0.296,0-0.587-0.145-0.762-0.408c-0.278-0.422-0.163-0.989,0.258-1.267 c1.045-0.693,1.589-1.451,1.492-2.081c-0.067-0.431-0.425-0.719-0.749-0.812c-0.238-0.066-0.575-0.077-0.86,0.254 c-2.662,3.095-5.026,2.827-6.2,2.391c-1.608-0.596-2.774-2.19-2.774-3.787c0-0.505,0.408-0.914,0.914-0.914 c0.505,0,0.914,0.408,0.914,0.914c0,0.73,0.591,1.706,1.582,2.074c1.252,0.465,2.74-0.196,4.179-1.87 c0.693-0.809,1.719-1.11,2.746-0.819c1.08,0.309,1.887,1.208,2.053,2.292c0.124,0.801-0.009,2.374-2.29,3.884 C248.952,260.168,248.777,260.218,248.604,260.218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M223.567,261.304c-0.193,0-0.387-0.061-0.553-0.185c-0.402-0.307-0.479-0.879-0.174-1.281 l19.864-26.119c0.19-0.343,0.262-0.818,0.344-1.365c0.153-1.026,0.345-2.303,1.911-3.245c1.021-0.612,2.232-0.595,3.245,0.052 c1.118,0.714,1.777,2.044,1.641,3.309c-0.082,0.769-0.531,2.172-2.612,2.943c-0.476,0.177-1-0.067-1.174-0.538 c-0.175-0.473,0.066-1,0.538-1.174c0.607-0.225,1.348-0.655,1.43-1.425c0.063-0.584-0.269-1.229-0.808-1.575 c-0.301-0.193-0.774-0.358-1.319-0.025c-0.829,0.498-0.911,1.044-1.047,1.949c-0.096,0.641-0.205,1.367-0.633,2.106l-19.927,26.214 C224.117,261.178,223.843,261.304,223.567,261.304z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "236.408,232.575 227.271,243.54 230.925,254.506 241.891,254.506 245.547,243.54  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M236.408,231.148l-10.166,12.199l4.024,12.074h12.282l4.024-12.074L236.408,231.148z  M228.298,243.736l7.197-8.636v18.493h-3.911L228.298,243.736z M241.233,253.593h-3.911V235.1l7.197,8.636L241.233,253.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M284.562,277.819l0.138-2.027c0,0,1.798-1.29,0.921-2.488c-0.875-1.198-1.889-1.429-4.009-1.152 c-2.12,0.277-5.438,0.231-6.866,0.322c-1.429,0.093-2.166,0.875-4.424,0.231l0.599-1.383c0,0-1.059,0.093-1.705,0.415 c-0.352,0.177-1.198-0.968-2.027-0.783c-0.826,0.183-1.659,1.889-2.95,2.765l0.691,1.383c0,0,0.783-0.369,1.383,0.046 c0.599,0.415,0.783,0.691,1.798,0.691l0.646,0.277c0,0-0.231,1.474,0.737,2.166c0,0-1.106,1.429-0.968,1.659 c0.138,0.231,1.059,1.982,1.429,2.995l0.83-1.567c0,0-1.245-1.106-1.014-1.245c0.231-0.138,1.059-0.322,0.921-0.691 c-0.138-0.369,0.646,0.046,1.521,0.184c0,0,0.046,1.383,0.231,1.567s0.461,0.921,0.415,1.705c-0.046,0.783-0.737,1.014-0.737,1.014 l1.245,0.369c0,0,0.322-0.461,0.553-0.415c0,0-0.093-3.825,0.415-4.424c0,0,2.995,0.599,4.377-0.138c0,0,0.177,0.223,0.522,0.435 c-0.138,0.321-0.255,0.641-0.203,0.735c0.116,0.209,0.486,0.185,0.578-0.046c0.035-0.087,0.089-0.266,0.143-0.451 c0.167,0.055,0.35,0.098,0.559,0.119c-0.02,0.291-0.022,0.559,0.045,0.621c0.174,0.161,0.519,0.024,0.535-0.225 c0.006-0.081,0.002-0.234-0.002-0.398c0.238-0.02,0.492-0.062,0.772-0.145l-1.567,2.581l-0.783,0.322l1.014,0.507l0.921-0.369 c0,0,0.875-2.212,2.304-2.857c0,0,0.968,2.304-0.231,3.549l1.059,0.599l0.507-1.059c0,0-0.184-2.073,0.507-3.41L284.562,277.819z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M267.209,271.235c0,0-0.462-0.439-0.578-1.017s-0.255-0.833-0.764-0.994c0,0,0.323,0.37,0.278,0.948 c-0.046,0.578,0,1.365,0.323,1.619L267.209,271.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M271.233,272.865c0,0-0.629,2.138-2.477,3.25l-0.646-0.277c0,0,1.973-1.686,2.212-3.134 L271.233,272.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.087,271.743c-0.066-0.068,0.81-0.323,0.601-1.017c-0.209-0.694-0.209-1.203,0.209-1.526 c0,0,0.046,0.578,0.37,0.948c0.323,0.37,0.509,1.295-0.023,1.827C269.245,271.974,268.712,272.391,268.087,271.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.188,278.049L268.188,278.049c-0.11-0.054-0.157-0.189-0.102-0.299l0.279-0.568 c0.163-0.333,0.055-0.747-0.266-0.932c-0.353-0.203-0.797-0.063-0.973,0.296l-0.29,0.59c-0.054,0.11-0.189,0.157-0.299,0.102 l-0.174,0.354c0,0,0.256,0.126,0.566,0.278l-0.007,0.013c-0.071,0.143-0.011,0.317,0.132,0.387 c0.143,0.071,0.317,0.011,0.387-0.132l0.007-0.013c0.31,0.152,0.566,0.278,0.566,0.278L268.188,278.049z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "270.424,281.944 271.117,282.083 270.539,283.864 269.954,282.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "272.12,283.902 271.697,284.65 273.362,284.65 273.365,284.271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "280.322,283.35 280.322,283.794 278.433,283.794 279.347,282.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "283.318,283.672 282.385,284.605 284.349,284.605 284.377,284.271  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M284.562,292.258l0.138-2.027c0,0,1.798-1.29,0.921-2.488c-0.875-1.198-1.889-1.429-4.009-1.152 s-5.438,0.231-6.866,0.322c-1.429,0.093-2.166,0.875-4.424,0.231l0.599-1.383c0,0-1.059,0.093-1.705,0.415 c-0.352,0.177-1.198-0.968-2.027-0.783c-0.826,0.183-1.659,1.889-2.95,2.765l0.691,1.383c0,0,0.783-0.369,1.383,0.046 c0.599,0.415,0.783,0.691,1.798,0.691l0.646,0.277c0,0-0.231,1.474,0.737,2.166c0,0-1.106,1.429-0.968,1.658 c0.138,0.231,1.059,1.982,1.429,2.995l0.83-1.567c0,0-1.245-1.106-1.014-1.245s1.059-0.322,0.921-0.691s0.646,0.046,1.521,0.184 c0,0,0.046,1.383,0.231,1.567c0.184,0.184,0.461,0.921,0.415,1.705c-0.046,0.783-0.737,1.014-0.737,1.014l1.245,0.369 c0,0,0.322-0.461,0.553-0.415c0,0-0.093-3.825,0.415-4.424c0,0,2.995,0.599,4.377-0.138c0,0,0.177,0.223,0.522,0.435 c-0.138,0.321-0.255,0.641-0.203,0.735c0.116,0.209,0.486,0.185,0.578-0.046c0.035-0.087,0.089-0.266,0.143-0.451 c0.167,0.055,0.35,0.098,0.559,0.119c-0.02,0.291-0.022,0.559,0.045,0.621c0.174,0.161,0.519,0.024,0.535-0.225 c0.006-0.081,0.002-0.234-0.002-0.398c0.238-0.02,0.492-0.062,0.772-0.145l-1.567,2.581l-0.783,0.322l1.014,0.507l0.921-0.369 c0,0,0.875-2.212,2.304-2.857c0,0,0.968,2.304-0.231,3.549l1.059,0.599l0.507-1.059c0,0-0.184-2.073,0.507-3.41L284.562,292.258z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M267.209,285.673c0,0-0.462-0.439-0.578-1.017s-0.255-0.833-0.764-0.994c0,0,0.323,0.37,0.278,0.948 c-0.046,0.578,0,1.365,0.323,1.619L267.209,285.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M271.233,287.303c0,0-0.629,2.138-2.477,3.25l-0.646-0.277c0,0,1.973-1.686,2.212-3.134 L271.233,287.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.087,286.182c-0.066-0.068,0.81-0.323,0.601-1.017c-0.209-0.694-0.209-1.203,0.209-1.527 c0,0,0.046,0.578,0.37,0.948s0.509,1.295-0.023,1.827C269.245,286.413,268.712,286.83,268.087,286.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.188,292.487L268.188,292.487c-0.11-0.054-0.157-0.189-0.102-0.299l0.279-0.568 c0.163-0.333,0.055-0.747-0.266-0.932c-0.353-0.203-0.797-0.063-0.973,0.296l-0.29,0.59c-0.054,0.11-0.189,0.157-0.299,0.102 l-0.174,0.354c0,0,0.256,0.126,0.566,0.278l-0.007,0.013c-0.071,0.143-0.011,0.317,0.132,0.387 c0.143,0.071,0.317,0.011,0.387-0.132l0.007-0.013c0.31,0.152,0.566,0.278,0.566,0.278L268.188,292.487z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "270.424,296.382 271.117,296.521 270.539,298.302 269.954,297.373  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "272.12,298.341 271.697,299.089 273.362,299.089 273.365,298.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "280.322,297.788 280.322,298.233 278.433,298.233 279.347,297.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "283.318,298.11 282.385,299.044 284.349,299.044 284.377,298.71  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.fb60fc0a9630fb76076662b227dd676f.svg";
export { ForwardRef as ReactComponent };